import { render, staticRenderFns } from "./AccountingMain.vue?vue&type=template&id=5f52ced8"
import script from "./AccountingMain.vue?vue&type=script&lang=js"
export * from "./AccountingMain.vue?vue&type=script&lang=js"
import style0 from "./AccountingMain.vue?vue&type=style&index=0&id=5f52ced8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports